var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3427_5221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.998 15.6328L16.2773 25.9453C16.084 26.1504 15.7676 26.25 15.5566 26.25C15.3231 26.25 15.0886 26.1694 14.9027 26.0065C14.5059 25.6586 14.4765 25.0655 14.8372 24.6829L23.0801 15.9375H0.97207C0.434707 15.9375 0 15.5183 0 15.0527C0 14.5872 0.434824 14.0625 0.97207 14.0625H23.0795L14.8354 5.31445C14.4746 4.93178 14.504 4.33828 14.9009 3.99082C15.2987 3.64477 15.9128 3.67037 16.2749 4.05492L25.9956 14.3674C26.332 14.7246 26.332 15.2754 25.998 15.6328Z",
    fill: "#363636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3427_5221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.25,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.d69465a660321af0a8e82b6fe1b75eea.svg";
export { ForwardRef as ReactComponent };